import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaKitaClub({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    facebook_account_name: false,
    facebook_club: false,
  });

  const JOIN_OPTIONS = ["Yes", "No"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      facebook_account_name: !primaryDetails.facebook_account_name,
      facebook_club: !primaryDetails.facebook_club,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please complete all required fields.", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigation.go("handling-and-merchant-concerns");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">MAYA KITA CLUB</h4>
              <p className="form-desc">Description (optional)</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>

                  {/* Facebook Account Name */}
                  <Form.Group className="mb-4" controlId="facebook_account_name">
                    <Form.Label className="form-label">
                      Facebook Account Name <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="facebook_account_name"
                      value={primaryDetails.facebook_account_name || ""}
                      onChange={handleInputChange}
                      placeholder="Put 'N/A' for non-Maya merchants"
                      className={`form-input ${isError.facebook_account_name ? "error" : ""}`}
                    />
                    {isError.facebook_account_name && (
                      <div className="form-error">Please enter Facebook Account Name.</div>
                    )}
                  </Form.Group>

                  {/* Joined Maya Kita Club Facebook Group */}
                  <Form.Group className="mb-4" controlId="facebook_club">
                    <Form.Label className="form-label">
                      Joined in Maya Kita Club Facebook Group <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {JOIN_OPTIONS.map((option, index) => (
                        <div
                          key={`join-kita-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.facebook_club === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="facebook_club"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.facebook_club === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.facebook_club && (
                      <div className="form-error">Please select Yes or No.</div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaKitaClub;
